import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import '../css/global.css'
import '../css/homepage.css'

export default class Home extends Component {
    render() {
        return (
            <div class="mainPageContainer">
                <div class="formContainer">
                    <h1>
                        Welcome to Area<strong class="numTitle">52</strong>
                    </h1>
                 <div class="buttonContainer">   
                    <Link class="formButtons" to='/signUp'>Sign UP</Link>
                    <Link class="formButtons" to='/login'>Sign In</Link>
                    </div>
                </div>
            </div>
        )
    }
}